<template>
    <div class="zzui-broadcast-window" :style="{height: height + 'px'}">
        <ul class="zzui-broadcast-container" ref="container"
        @mouseover="handleHover(true)"
        @mouseout="handleHover(false)">
            <slot></slot>
        </ul>
    </div>
    
</template>
<script>
import { clearInterval } from 'timers';

let Timer = null;
export default{
    data (){
        return {
            height: '',
            speed: '',
            length: 0,
            currentIndex: 0
        }
    },
    props: {
        interval: {
            type: Number,
            default: 3000 //ms
        },
        duration: {
            type: Number,
            default: 600 //ms
        },
        direction: {
            validator (val){
                return val === 'up' || val === 'down';
            },
            default: 'up'
        },
    },
    mounted (){
        this.fixList();
    },
    beforeDestroy() {
        window.clearInterval(Timer);
        Timer = null;
    },
    methods: {
        /*
         * 根据方向将第一个或最后一个item复制添加到列表最后或前面，保证下一次轮播连贯
         * 将单个item高度设置为广播视窗高度
         */
        fixList (){
            let box = this.$refs.container,
                Height = box.offsetHeight,
                itemHeight = box.firstChild.offsetHeight,
                itemLength = box.children.length;
                
            
            let cloneNode,
                firstItem = this.$refs.container.firstElementChild;
           
            let boxHeight = document.getElementsByClassName("fault_list")[0].offsetHeight;
            
            if(boxHeight> itemHeight*itemLength) {
                return
            }
            // 根据item高度设置视窗container高度
            this.length = itemLength;
            this.speed = itemHeight;

            if(this.direction === 'up'){
                // 向上则clone第一个item置于列表末端
                for (let i = 0; i < itemLength; i++) {
                    cloneNode = box.children[i].cloneNode(true);
                    box.appendChild(cloneNode);
                }
            }else{
                // 向下则clone最后一个item置于列表首部
                for (let i = 0; i < itemLength; i++) {
                    cloneNode = box.children[i].cloneNode(true);
                    box.insertBefore(cloneNode, firstItem);
                }
            }

            this.$nextTick(()=>{
                // 用总高度/length，减小较小
                this.height = itemHeight * parseInt(Height/itemHeight);
            });

            this.start();
        },
        /*
         * 启动轮播
         */
        start (){
            let currenTransitionTime,
                currenTranslateY;
            // 方向向下，列表初始时跳转到最后item
            if(this.direction === 'down')this.quickJump(false);

            Timer = setInterval(()=>{
                if(this.direction === 'up'){
                    this.currentIndex += 1;
                }else{
                    this.currentIndex -= 1;
                }

                // 正常轮播transition时间为用户设置duration时间
                currenTransitionTime = 'transform ' + this.duration+ 'ms ease-in-out';
                this.setTransition(this.$refs.container, currenTransitionTime);

                // 正常轮播每次currenTranslateY增加一个item高度
                if(this.direction === 'up'){
                    currenTranslateY = -this.currentIndex * this.speed + 'px';
                }else{
                    currenTranslateY = - (this.currentIndex + 1) * this.speed + 'px';
                }

                this.setTransform(this.$refs.container, 'translate3d(0,' + currenTranslateY + ',0)');

                // 当滑动到首尾边界替补item时，需即刻跳转到正确item位置
                if(this.currentIndex == this.length){
                    setTimeout(()=>{
                        this.quickJump(true);
                    }, this.duration);
                }else if(this.currentIndex == -1){
                    setTimeout(()=>{
                        this.quickJump(false);
                    }, this.duration);
                }
            }, this.interval + this.duration);
        },
        handleHover(bool) {
            if(bool) {
                // 进入
                if(Timer){
                    window.clearInterval(Timer);
                    Timer = null;
                }
            } else {
                // 移除
                if(!Timer) {
                    this.start();
                }
            }
        },
        /*
         * 设置transition 0ms，再设置translatet位置启动跳转
         * 由于跳转前后展现的内容完全一样，肉眼看不到跳转过程
         */
        quickJump (toFirst){            
            let currenTranslateY,
                currenTransitionTime = 'transform 0ms ease-in-out';

            this.setTransition(this.$refs.container, currenTransitionTime);

            if(toFirst){
                // 跳转到首个item
                this.currentIndex = 0;
                currenTranslateY = '0px';
            }else{
                this.currentIndex = this.length - 1;
                currenTranslateY = - (this.currentIndex + 1) * this.height + 'px';
            }
            
            this.setTransform(this.$refs.container, 'translate3d(0,' + currenTranslateY + ',0)');
        },
        /*
         * transition添加浏览器前缀
         * transform同
         */
        setTransition (ele, val){
            ele.style.transition = val;
            ele.style.WebkitTransition = '-webkit-' + val;
            ele.style.MozTransition = '-moz-' + val;
            ele.style.OTransition = '-o-' + val;
        },
        setTransform (ele, val){
            ele.style.transform = val;
            ele.style.WebkitTransform = val;
            ele.style.MozTransform = val;
            ele.style.OTransform = val;
        }
    }
}
</script>
<style lang="less">
    .zzui-broadcast-window{
        width: 100%;
        overflow: hidden;
        transform: translateZ(0);
        height: 100%;
        .zzui-broadcast-container{
            padding: 0;
            margin: 0;
            width: 100%;
            height: auto;
            li{
                margin: 0;
                height: 40px;
                line-height: 40px;
                &:nth-child(2n){
                    background-color: #fafafa;
                }
                &:hover{
                    background-color: #f5f7fa;
                }
            }
        }
    }
</style>
